









































import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import Link from '@/components/Link.vue'
import { ButtonAction } from '@/contracts/ButtonHeroAction'
import BlockButtons from '@/components/BlockButtons.vue'

@Component
class CardIcon extends Vue {
  @Prop() readonly iconName: String = ''
  @Prop() readonly iconNameMobile: String = ''
  @Prop() readonly title: String = ''
  @Prop() readonly description: String = ''
  @Prop() readonly linkText: String = ''
  @Prop() readonly linkUrl: String = ''
  @Prop() readonly iconLink: String = ''
  @Prop() readonly clipAngles: Boolean = false
  @Prop() readonly actionButtons: ButtonAction[] = []
  static options: any
}

export default defineComponent({
  name: 'CardIcon',
  components: { BlockButtons, Link },
  props: CardIcon.options.props,
  setup() {},
})
